import React, { Component } from 'react'
class ListView extends Component {
  state = {}
  render() {
    const { component, hideTop, showButton } = this.props
    return (
      <React.Fragment>
        {hideTop && hideTop}
        {component && component}
        {showButton && showButton}
      </React.Fragment>
    )
  }
}

export default ListView



// WEBPACK FOOTER //
// ./src/components/ListView.js